import FranchiseUs from "./FranchiseUs"
import BeAPartner from "./BeAPartner"
import ContactUs from "./ContactUs";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";
export {FranchiseUs, BeAPartner, ContactUs, PrivacyPolicy, TermsOfService};